import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private activeRequests = 0;
  
  // Expose as readonly signals
  isLoading = signal<boolean>(false);
  activeModuleKey = signal<string>('dashboard');

  show(moduleKey?: string) {
    if (moduleKey) {
      this.activeModuleKey.set(moduleKey);
    }
    this.startLoading();
  }

  hide(moduleKey?: string) {
    this.stopLoading();
  }

  startLoading() {
    this.activeRequests++;
    this.isLoading.set(true);
  }

  stopLoading() {
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }
    if (this.activeRequests === 0) {
      this.isLoading.set(false);
    }
  }
}
